{
  "biomes": [
    { "name": "highlands", "base": "rock" },
    { "name": "desert",    "base": "sand" },
    { "name": "grove",     "base": "moss" },
    { "name": "tundra",    "base": "ice"  },
    { "name": "ember",     "base": "ash"  }
  ],
  "biomeNoise": { "scale": 1400, "octaves": 2 },

  "materials": {
    "air":  { "id": 0, "solid": false },
    "rock": { "id": 1, "solid": true, "fill": "#33405e", "line": "#5f7bb0" },
    "wood": { "id": 2, "solid": true, "fill": "#6b4a2b", "line": "#a9793f" },
    "sand": { "id": 3, "solid": true, "fill": "#5c4a29", "line": "#c39a52" },
    "moss": { "id": 4, "solid": true, "fill": "#2e4a33", "line": "#63b06f" },
    "ice":  { "id": 5, "solid": true, "fill": "#38505e", "line": "#86cadd" },
    "ash":  { "id": 6, "solid": true, "fill": "#4d2f39", "line": "#c76c7e" },
    "dirt":  { "id": 7, "solid": true, "fill": "#4f3a24", "line": "#7d5c38" },
    "grass": { "id": 8, "solid": true, "fill": "#356b2e", "line": "#63c257" },
    "water": { "id": 9, "solid": false, "fill": "#2b5a8a", "line": "#4a8fd0" },
    "custom": { "id": 10, "solid": true, "buildable": false, "fill": "#3a3550", "line": "#6a6488" }
  },

  "modifiers": {
    "none":       { "id": 0 },
    "doorOpen":   { "id": 1, "solid": false },
    "doorClosed": { "id": 2, "solid": true }
  }
}
